export const FieldConstants = Object.freeze({
  NONE: 'None',
})

export const NONE_ID = 'none'
export const NONE_NAME = 'None'

// Placed in a control's framework column on CSV export when the control is
// linked to that framework but has no requirement links — there's otherwise no
// way to represent "framework, no requirements" in the column. On import this
// signals: add the framework link, add no requirements.
export const NO_REQUIREMENTS_INDICATOR = '<no requirements>'

export const INPUT_MAX_LENGTH = 255

export const COMPANY_NAME_ADMIN_MESSAGE =
  'You must be an admin user to edit the company name.'

export const AI_LOADING_MESSAGES = [
  'Doing my research',
  'Digging into the details',
  'Checking the playbook',
  'Exploring options',
  'Finding the best path',
  'Reviewing best practices',
]

export const TYPEWRITER_INTERVAL = 10

export const SCHEDULER_EMAIL = 'scheduler@trustero.com'

// The Learn More destination for surfaces with no support article of their own
// yet -- the questionnaire tabs, which link here rather than to a HUBSPOT
// knowledge-base entry because none covers them.
export const TRUSTERO_HOME = 'https://www.trustero.com/'
